/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Businesstelefone1Inputs */

const de__field_businesstelefone1 = /** @type {(inputs: _Field_Businesstelefone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handynummer (dienstlich)`)
};

/**

* @param {_Field_Businesstelefone1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_businesstelefone1 = /** @type {((inputs?: _Field_Businesstelefone1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Businesstelefone1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_businesstelefone1(inputs)
});
export { _field_businesstelefone1 as "_field_businessTelefone" }